export function formatQuantity(value?: number | null): string {
    return value == null ? '' : String(value);
}
